export const AUDIT_TYPE = {
  VIEW_POLICY: 500,
  TOGGLE_AUTO_RENEWAL_ON_SUCCESS: 501,
  TOGGLE_AUTO_RENEWAL_ON_FAILURE: 502,
  TOGGLE_AUTO_RENEWAL_OFF_SUCCESS: 503,
  TOGGLE_AUTO_RENEWAL_OFF_FAILURE: 504,
  DOWNLOAD_DOCUMENT_SUCCESS: 505,
  EMAIL_DOCUMENT_SUCCESS: 506,
  DOWNLOAD_DOCUMENT_FAILURE: 507,
  EMAIL_DOCUMENT_FAILURE: 508,
  START_CLAIM: 509,
  RETRIEVE_QUOTE: 510,
  TOGGLE_PRINT_DOCUMENTS_ON_SUCCESS: 511,
  TOGGLE_PRINT_DOCUMENTS_ON_FAILURE: 512,
  TOGGLE_PRINT_DOCUMENTS_OFF_SUCCESS: 513,
  TOGGLE_PRINT_DOCUMENTS_OFF_FAILURE: 514,
  RENEWAL_JOURNEY_ACCESS_VALIDATION_SUCCESS: 519,
  RENEWAL_JOURNEY_ACCESS_VALIDATION_FAILURE: 520,
  PAYMENT_FAILURE_MESSAGE_RECEIVED: 523,
  PAYMENT_SUCCESS_MESSAGE_RECEIVED: 524
} as const;

export type AuditType = (typeof AUDIT_TYPE)[keyof typeof AUDIT_TYPE];

export const AUDIT_DESCRIPTION: Record<AuditType, string> = {
  [AUDIT_TYPE.VIEW_POLICY]: 'Policy viewed in the portal',
  [AUDIT_TYPE.TOGGLE_AUTO_RENEWAL_ON_SUCCESS]: 'Successfully toggled auto renewal on',
  [AUDIT_TYPE.TOGGLE_AUTO_RENEWAL_ON_FAILURE]: 'Failed to toggle auto renewal on',
  [AUDIT_TYPE.TOGGLE_AUTO_RENEWAL_OFF_SUCCESS]: 'Successfully toggled auto renewal off',
  [AUDIT_TYPE.TOGGLE_AUTO_RENEWAL_OFF_FAILURE]: 'Failed to toggle auto renewal off',
  [AUDIT_TYPE.DOWNLOAD_DOCUMENT_SUCCESS]: 'Successfully downloaded document',
  [AUDIT_TYPE.DOWNLOAD_DOCUMENT_FAILURE]: 'Failed to download document',
  [AUDIT_TYPE.EMAIL_DOCUMENT_SUCCESS]: 'Successfully emailed document to customer',
  [AUDIT_TYPE.EMAIL_DOCUMENT_FAILURE]: 'Failed to email document to customer',
  [AUDIT_TYPE.START_CLAIM]: 'User clicks start a claim',
  [AUDIT_TYPE.RETRIEVE_QUOTE]: 'User clicks a button to retrieve the quote from NHI',
  [AUDIT_TYPE.TOGGLE_PRINT_DOCUMENTS_ON_SUCCESS]: 'Successfully toggled print documents on',
  [AUDIT_TYPE.TOGGLE_PRINT_DOCUMENTS_ON_FAILURE]: 'Failed to toggle print documents on',
  [AUDIT_TYPE.TOGGLE_PRINT_DOCUMENTS_OFF_SUCCESS]: 'Successfully toggled print documents off',
  [AUDIT_TYPE.TOGGLE_PRINT_DOCUMENTS_OFF_FAILURE]: 'Failed to toggle print documents off',
  [AUDIT_TYPE.RENEWAL_JOURNEY_ACCESS_VALIDATION_SUCCESS]: 'Successfully granted access to renewal journey',
  [AUDIT_TYPE.RENEWAL_JOURNEY_ACCESS_VALIDATION_FAILURE]: 'Prevented from accessing renewal journey',
  [AUDIT_TYPE.PAYMENT_SUCCESS_MESSAGE_RECEIVED]: 'Received success message from payment portal',
  [AUDIT_TYPE.PAYMENT_FAILURE_MESSAGE_RECEIVED]: ' Received failure message from payment portal'
};
